module.exports = __webpack_public_path__ + "static/img/detail_pic2.6b9291e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail_pic2.png
// module id = mY28
// module chunks = 19